// ─────────────────────────────────────────────────────────────────────────────
// Single registry of the prototype demos.
//
// Both the landing page grid and the in-page tab bar read from this, so adding
// a demo means adding one entry here plus a route in App.tsx.
//
// Display strings live in i18n.tsx under `proto.<num>.*` — this file holds
// only the structure.
// ─────────────────────────────────────────────────────────────────────────────

export type PrototypeStatus = 'available' | 'coming-soon';

export interface PrototypeMeta {
  /** Two-digit index shown in the tab bar and on the cards. */
  num: string;
  status: PrototypeStatus;
  path: string;
}

export const PROTOTYPES: PrototypeMeta[] = [
  { num: '01', status: 'available', path: '/prototype/1' },
  { num: '02', status: 'available', path: '/prototype/2' },
  { num: '03', status: 'available', path: '/prototype/3' },
  { num: '04', status: 'available', path: '/prototype/4' },
  { num: '05', status: 'available', path: '/prototype/5' },
];

export const findPrototype = (num: string) =>
  PROTOTYPES.find(p => p.num === num);
